import { AnyAction } from "redux";
import { FindById, Update } from "../../../commons";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { SearchersAdapter } from "../../../../adapter/searchers-adapter";

export const FETCH_UPDATE_COMMON_REQUEST = 'FETCH_UPDATE_COMMON_REQUEST';
export const FETCH_UPDATE_COMMON_SUCCESS = 'FETCH_UPDATE_COMMON_SUCCESS';
export const FETCH_UPDATE_COMMON_FAILURE = 'FETCH_UPDATE_COMMON_FAILURE';
export const SET_UPDATE_COMMON = 'SET_UPDATE_COMMON';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchUpdateCommonRequest = () => {
    return {
        type: FETCH_UPDATE_COMMON_REQUEST,
    };
};

const fetchUpdateCommonSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_UPDATE_COMMON_SUCCESS,
        payload: data
    };
};

const fetchUpdateCommonFailure = (error: any) => {
    return {
        type: FETCH_UPDATE_COMMON_FAILURE,
        payload: error,
    };
};

export const setUpdateCommon = (data: any) => {
    return {
        type: SET_UPDATE_COMMON,
        payload: data,
    };
};

export const update = (id: string, data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateCommonRequest());
        try {
            const response = await Update(id, data);
            dispatch(fetchUpdateCommonSuccess(
                Adapter.from(response.data).to((value) => new SearchersAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchUpdateCommonFailure(error.message));
        }
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateCommonRequest());
        try {
            const response = await FindById(id);
            dispatch(setUpdateCommon(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchUpdateCommonFailure(error.message));
        }
    };
};
